import React from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import { Button, Typography } from '@occc/ui-design-system';
import { Select } from '@occc-app/design-system';

import { AudienceFilterFormValues } from '../types';
import { statusOptions as defaultStatusOptions } from '../constants';

export type AudiencesFilterFormProps = {
  onSubmit: FormProps<AudienceFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: AudienceFilterFormValues;
  statusOptions?: typeof defaultStatusOptions;
};

export const AudienceFilterForm: React.FC<AudiencesFilterFormProps> = ({
  onReset,
  onSubmit,
  initialValues,
  statusOptions = defaultStatusOptions,
}) => {
  const renderForm: FormRenderProps<AudienceFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form }: FormRenderProps<AudienceFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onReset();
      };

      return (
        <form onSubmit={handleSubmit}>
          <Box px={4} pt={4}>
            <Typography paragraph>Status</Typography>
            <Select name='status' label='Status' data={statusOptions} />
          </Box>
          <Box display='flex' justifyContent='flex-end' px={3} py={2}>
            <Button size='small' color='error' onClick={reset}>
              reset
            </Button>
            <Button type='submit' size='small' color='primary'>
              apply
            </Button>
          </Box>
        </form>
      );
    },
    [onReset, statusOptions],
  );

  return (
    <Form<AudienceFilterFormValues>
      render={renderForm}
      onSubmit={onSubmit}
      initialValues={initialValues}
    />
  );
};
